import { EventMutationBuyLimit } from './event-mutation-buy-limit';
import { EventMutationBuyMarket } from './event-mutation-buy-market';
import { EventMutationSellLimit } from './event-mutation-sell-limit';
import { EventMutationSellMarket } from './event-mutation-sell-market';

import { ORDER_TYPE } from '@/constants/solana';

export enum EOrder {
  MARKET,
  LIMIT,
}

export const tradesElements = {
  [ORDER_TYPE.BUY]: {
    [EOrder.LIMIT]: EventMutationBuyLimit,
    [EOrder.MARKET]: EventMutationBuyMarket,
  },
  [ORDER_TYPE.SELL]: {
    [EOrder.LIMIT]: EventMutationSellLimit,
    [EOrder.MARKET]: EventMutationSellMarket,
  },
} as const;
